function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione03Img01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275.62 318.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "p07-persona"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.5,21.64c-1.08-3.1-3.17-5.85-5.84-7.74-1.29-3.18-3.27-6.07-5.85-8.34-4.93-4.33-11.67-6.28-18.14-5.33-1.71.25-3.51.82-4.43,2.4-.41.72-.58,1.51-.59,2.32-1.83.31-3.6,1.04-5.12,2.2-3.4,2.59-5.19,6.91-4.67,11.15.24,1.97,1.05,4.35.3,6.29-.34.89-1.07,1.47-1.85,1.97-.92.59-1.84,1.14-2.68,1.84-3.39,2.82-5.3,7.24-6.42,11.41-2.31,8.6-1.2,18.41,4.17,25.69,4.83,6.55,12.74,11.05,21,10.71,2.79-.11,5.56-.8,8.13-1.95.2.08.43.11.69.05,4.91-1.06,8.96-4.69,11.2-9.1,2.7-5.31,2.79-11.51,1.62-17.24-.15-.74-.33-1.48-.52-2.21-.19-.74-.47-1.52-.4-2.3.1-1.09.97-1.86,1.79-2.49.98-.75,2.03-1.42,2.95-2.25.93-.85,1.74-1.81,2.46-2.85,2.82-4.06,3.84-9.52,2.2-14.24",
    style: {
      fill: "#004996"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.66,110.98l-6.94,194.02,10.13,9.68c1.08,1.03.35,2.86-1.15,2.86h-54.73c-5.51,0-9.71-4.94-8.83-10.38l27.95-170.93,33.57-25.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,136.55l-27.91,170.7c-.4,2.42.29,4.89,1.88,6.76s3.91,2.95,6.37,2.95h54.73c.45,0,.83-.25,1-.67.17-.42.07-.86-.25-1.18l-10.13-9.68c-.12-.12-.19-.28-.18-.44l6.9-192.8-32.4,24.36ZM151.7,318.12h-54.73c-2.8,0-5.45-1.22-7.26-3.36-1.81-2.13-2.59-4.94-2.14-7.71l27.95-170.93c.02-.15.11-.28.23-.37l33.57-25.24c.18-.14.42-.16.62-.05.2.1.32.31.31.54l-6.93,193.76,9.94,9.5c.68.65.88,1.59.53,2.46-.35.87-1.15,1.41-2.08,1.41",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.51,112.76L1.18,309.17c-1.89,3.86.92,8.37,5.22,8.37h50.6c1.61,0,2.63-1.72,1.86-3.13l-5.12-9.41,75.28-167.27,12.97-5.95,7.66-20.8-52.15,1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,318.12H6.4c-2.22,0-4.25-1.13-5.43-3.01-1.18-1.89-1.29-4.21-.31-6.2L96.99,112.51c.14-.29.49-.41.78-.27.29.14.41.49.27.78L1.71,309.42c-.8,1.63-.71,3.53.26,5.07s2.62,2.46,4.44,2.46h50.6c.55,0,1.04-.28,1.32-.75.28-.47.29-1.04.03-1.51l-5.12-9.41c-.09-.16-.09-.35-.02-.52l73.6-163.53c1.15-2.54,3.17-4.59,5.71-5.75l2.59-1.19c.3-.13.64,0,.78.29.13.29,0,.64-.29.78l-2.59,1.19c-2.28,1.04-4.1,2.88-5.13,5.17l-73.48,163.26,4.98,9.15c.46.84.44,1.84-.05,2.67-.49.83-1.36,1.32-2.32,1.32",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35,285.16c-7.83,0-15.65-.71-23.42-2.14-.32-.06-.53-.36-.47-.68.06-.32.36-.53.68-.47,15.1,2.77,30.43,2.82,45.55.16.32-.06.62.16.68.47.06.32-.16.62-.47.68-7.48,1.32-15.02,1.98-22.55,1.98",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.84,286.56c-8.39,0-16.77-.98-24.88-2.92-.31-.08-.51-.39-.43-.71.08-.32.39-.51.71-.43,14.43,3.47,29.75,3.82,44.33,1.04.32-.06.62.15.68.46.06.32-.15.62-.46.68-6.54,1.25-13.24,1.87-19.93,1.87",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.15,107.49s-7.57-55.62-18.99-57.85l-4.63,56.32,23.62,1.53Z",
    style: {
      fill: "#004996"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,124.69l17.38-76.96s32.1-.65,43.38,1.9c0,0-3.23,58.17-4.9,76.88l-55.86-1.81Z",
    style: {
      fill: "#004996"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.56,57.09l43.47-5.49-34.43,27.47L40.1,161.74c-7.29,3-15.23.52-17.73-5.55-2.5-6.07,1.39-13.42,8.68-16.42L231.56,57.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.71,57.66L31.28,140.3c-3.4,1.4-6.14,3.81-7.72,6.79-1.56,2.95-1.79,6.1-.64,8.87,2.37,5.76,9.98,8.11,16.96,5.24l200.43-82.64,32.74-26.12-41.33,5.22ZM33.81,163.6c-5.34,0-10.1-2.64-11.97-7.18-1.28-3.1-1.03-6.6.69-9.86,1.7-3.22,4.65-5.83,8.31-7.33L231.34,56.55s.1-.03.15-.04l43.47-5.49c.26-.03.51.11.61.35.1.24.03.52-.17.68l-34.43,27.47s-.09.06-.14.08L40.33,162.28c-2.16.89-4.39,1.31-6.52,1.31",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.96 64.42 275.04 51.6 254.74 54.16 258.96 64.42",
    style: {
      fill: "#004996"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.67,131.27l8.98,21.81c.72,1.75-.11,3.75-1.86,4.47l-.61.25c-1.75.72-3.75-.11-4.47-1.87l-8.98-21.81c-.72-1.75.11-3.75,1.86-4.47l.61-.25c1.75-.72,3.75.11,4.47,1.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,129.73c-.36,0-.72.07-1.08.21l-.61.25c-.7.29-1.25.83-1.54,1.54-.29.7-.29,1.47,0,2.18l8.98,21.81c.29.7.83,1.25,1.54,1.54.7.29,1.47.29,2.18,0l.61-.25c1.45-.6,2.14-2.26,1.55-3.71l-8.98-21.81c-.45-1.1-1.51-1.76-2.63-1.76M56.87,158.64c-.52,0-1.05-.1-1.54-.31-.99-.41-1.76-1.19-2.17-2.18l-8.98-21.81c-.41-.99-.41-2.08,0-3.07.41-.99,1.19-1.76,2.18-2.17l.61-.25c2.05-.84,4.4.14,5.24,2.18l8.98,21.81c.84,2.05-.14,4.4-2.18,5.24l-.61.25c-.49.2-1.01.3-1.53.3",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.71,128.37l8.98,21.81c.72,1.75-.11,3.75-1.86,4.47l-.61.25c-1.75.72-3.75-.11-4.47-1.87l-8.98-21.81c-.72-1.75.11-3.75,1.86-4.48l.61-.25c1.75-.72,3.75.11,4.47,1.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.54,126.83c-.36,0-.73.07-1.08.21l-.61.25c-1.45.6-2.14,2.26-1.55,3.71l8.98,21.81c.6,1.45,2.26,2.14,3.71,1.55l.61-.25c.7-.29,1.25-.83,1.54-1.54.29-.7.29-1.47,0-2.18l-8.98-21.81c-.45-1.1-1.51-1.76-2.63-1.76M63.91,155.75c-1.58,0-3.08-.94-3.72-2.49l-8.98-21.81c-.84-2.05.14-4.4,2.18-5.24l.61-.25c2.04-.84,4.4.14,5.24,2.18l8.98,21.81c.41.99.41,2.08,0,3.07-.41.99-1.19,1.76-2.18,2.17l-.61.25c-.5.21-1.01.3-1.52.3",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.14,79.65s-.07,0-.11,0c-1.61-.3-3.02-1.58-3.78-3.42-.78-1.9-.67-3.95.3-5.35.18-.26.55-.33.81-.15.27.18.33.55.15.81-.75,1.08-.82,2.7-.18,4.24.61,1.47,1.7,2.49,2.92,2.72.32.06.53.36.47.68-.05.28-.3.48-.57.48",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.01,71.72s-.07,0-.11,0c-1.68-.31-2.98-1.32-3.58-2.77-.6-1.45-.38-3.09.59-4.49.18-.26.55-.33.81-.15.26.18.33.55.15.81-.74,1.07-.92,2.3-.47,3.38.44,1.07,1.43,1.83,2.71,2.06.32.06.53.36.47.68-.05.28-.3.48-.57.48",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.37,65.31s-.07,0-.11,0c-1.59-.3-2.96-1.5-3.67-3.23-.75-1.82-.6-3.83.38-5.25.18-.26.55-.33.81-.15.27.18.33.55.15.81-.76,1.1-.86,2.68-.26,4.14.56,1.36,1.61,2.3,2.8,2.52.32.06.53.36.47.68-.05.28-.3.48-.57.48",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.79,138.7c-.23,0-.45-.14-.54-.36-.12-.3.02-.64.32-.76l162.05-66.84c.3-.12.64.02.76.32.12.3-.02.64-.32.76l-162.05,66.84c-.07.03-.15.04-.22.04",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.13,132.25c-.23,0-.45-.14-.54-.36-.12-.3.02-.64.32-.76l162.05-66.84c.3-.12.64.02.76.32.12.3-.02.64-.32.76l-162.05,66.84c-.07.03-.15.04-.22.04",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.34,97.76c-.55-1.05-2.28-3.15-2.28-3.15l-.08.04c-2.88-3.17-9.69-8.85-19.39-5.25-13.09,4.86-31.74,16.52-31.74,16.52,0,0,17.22-46.78,12.96-58.2,0,0-22.56,6.77-32.99,40.5-10.43,33.72,5.13,45.18,16.17,45.38,11.04.2,38.73-28.94,43.09-28.93,0,0,2.22,1.65,3.77,1.52,1.55-.14,2.1-1.64,2.1-2.97,0,0,1.41,1.19,3.06.64,1.64-.55,1.69-2.01,1.78-2.55,0,0,2.05.78,3.29-.05,1.23-.82.82-2.46.27-3.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.95,91.04c3.68.01,8.69-.06,12.36-.22,4.69-14.72,11.74-36,6.49-43.09,0,0-22.56,6.77-32.99,40.5-.25.79-.47,1.57-.69,2.34,4.94.28,9.88.45,14.83.47",
    style: {
      fill: "#004996"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.09,134.2s-.08,0-.12,0c-5.77-.1-11.39-3.07-15.03-7.93-4.08-5.46-7.84-15.99-2.57-35.2.09-.31.41-.49.72-.41.31.09.49.41.41.72-5.15,18.75-1.55,28.94,2.37,34.19,3.43,4.58,8.7,7.37,14.12,7.47.03,0,.07,0,.1,0,6.62,0,19.85-11.11,29.52-19.23,7.38-6.19,11.65-9.7,13.45-9.7h0c.32,0,.58.26.58.59,0,.32-.27.61-.59.58h0c-1.47,0-7.18,4.79-12.7,9.43-10.36,8.69-23.23,19.5-30.28,19.5",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.09,134.2s-.08,0-.12,0c-.32,0-.58-.27-.57-.6,0-.32.28-.58.6-.57.03,0,.07,0,.1,0,6.62,0,19.85-11.11,29.52-19.23,7.38-6.19,11.65-9.7,13.45-9.7h0c.12,0,.24.04.34.11.7.5,2.97,1.8,4.08,1.23.54-.28.81-1.03.81-2.23,0-.22.13-.43.33-.53.2-.1.44-.07.62.07.63.51,2.08.93,3,.47.62-.31.91-1,.87-2.06,0-.2.09-.39.25-.5.16-.11.37-.13.56-.06,1.17.48,2.26.58,2.83.25.29-.17.46-.46.52-.89.21-1.63-2.76-6.48-8.05-9.22-.29-.15-.4-.5-.25-.79.15-.29.5-.4.79-.25,5.2,2.69,9,7.9,8.67,10.41-.13,1-.67,1.5-1.09,1.75-.75.44-1.85.47-3.09.1-.17,1.35-.87,2-1.49,2.3-1.07.54-2.4.33-3.37-.08-.16,1.13-.62,1.91-1.39,2.3-1.76.9-4.36-.69-5.12-1.19-1.68.3-7.2,4.93-12.54,9.41-10.36,8.69-23.23,19.5-30.28,19.5",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.96,103.85c-.24,0-.47-.15-.55-.39-.84-2.41-4.33-4.51-7.08-5.07-.32-.06-.52-.37-.46-.69.06-.32.37-.52.69-.46,3.13.64,6.97,2.99,7.95,5.83.11.31-.06.64-.36.74-.06.02-.13.03-.19.03",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.72,101.66c-.2,0-.39-.1-.5-.29-2.26-3.78-4.62-5.66-8.17-6.49-.31-.07-.51-.39-.44-.7.07-.31.38-.51.7-.44,3.89.91,6.46,2.95,8.9,7.03.17.28.08.64-.2.8-.09.06-.2.08-.3.08",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.77,106.62c10.32-9.4,4.04-23.5.79-24.68-1.82-.66-2.72,1.23-2.89,3.18-3.28-1.84-4.36,1.76-4.05,3.34-5.01-2.59-3.98,4.49-3.98,4.49l-47.31,20.06s47.12,3,57.44-6.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.9,112.57c9.89.45,45.82,1.51,54.48-6.38,6.11-5.56,5.83-12.38,5.12-15.96-.86-4.33-2.99-7.32-4.14-7.74-.41-.15-.74-.13-1.03.05-.56.36-.97,1.37-1.08,2.63-.02.2-.13.37-.31.47-.17.09-.39.09-.56,0-.92-.52-1.67-.57-2.23-.17-.83.61-1.12,2.08-.96,2.88.04.22-.04.45-.22.58-.18.13-.42.15-.62.05-1.06-.55-1.86-.65-2.35-.3-1.03.73-.91,3.33-.78,4.19.04.26-.11.52-.35.62l-44.97,19.07ZM175,114.08c-8.97,0-15.97-.43-16.7-.48-.27-.02-.49-.22-.54-.49-.05-.27.1-.53.35-.64l46.9-19.89c-.1-1.11-.17-3.8,1.32-4.86.7-.5,1.59-.55,2.68-.18.07-1.05.5-2.32,1.47-3.03.55-.4,1.45-.73,2.73-.26.24-1.27.77-2.23,1.5-2.7.42-.27,1.11-.51,2.06-.17,1.92.69,4.07,4.48,4.89,8.61.76,3.81,1.05,11.1-5.48,17.05-6.45,5.87-26.46,7.03-41.17,7.03",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.99,98.14c-.05,0-.11,0-.16-.02-.31-.09-.49-.41-.4-.72.76-2.7.5-6.77-1.25-8.62-.22-.23-.21-.6.02-.83.23-.22.6-.21.83.02,2.07,2.18,2.4,6.66,1.53,9.74-.07.26-.31.43-.56.43",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.82,96.43s-.1,0-.14-.02c-.31-.08-.5-.4-.42-.71.89-3.53.3-6.49-2.02-10.23-.17-.27-.09-.63.19-.81.27-.17.63-.09.8.19,2.51,4.04,3.14,7.26,2.16,11.13-.07.26-.31.44-.57.44",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,28.72l-7.54,19.12s4.23,5.58,13.72,6.85c9.49,1.27,1.41-6.67,1.41-6.67l4.58-13.11-12.17-6.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.49 48.03 149.07 34.92 136.9 28.72 129.36 47.84 144.49 48.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,48.61c-.06,0-.13,0-.19-.03-.31-.11-.47-.44-.36-.74l4.41-12.63-11.14-5.67-7.31,18.53c-.12.3-.46.45-.76.33-.3-.12-.45-.46-.33-.76l7.55-19.12c.06-.15.18-.27.34-.33.15-.06.32-.05.47.03l12.17,6.2c.26.13.38.44.29.71l-4.58,13.11c-.08.24-.31.39-.55.39",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,27.18c-.28,2.91-1.09,5.82-2.78,8.2-1.69,2.38-4.32,4.19-7.23,4.44-2.52.22-5.06-.72-7.05-2.3-1.98-1.58-3.43-3.74-4.46-6.05-2.64.17-5.28-1.65-6.06-4.18-.45-1.46-.26-3.18.76-4.31,1.03-1.13,2.96-1.43,4.11-.43.65.57.99,1.45,1.66,2,.76.61,1.84.68,2.77.38.92-.3,1.7-.93,2.38-1.63,2.13-2.19,3.43-5.17,3.58-8.22-.01.29,1.31,1.1,1.54,1.26.58.4,1.2.75,1.84,1.05,1.27.58,2.63.95,4.02,1.1.7.07,1.41.09,2.12.04.56-.04,1.36-.33,1.9-.18,1.14.31.89,2.47.94,3.35.1,1.82.12,3.65-.05,5.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,27.18h0,0ZM136.99,30.89c.23,0,.44.13.53.35,1.11,2.48,2.55,4.45,4.29,5.83,1.98,1.58,4.4,2.37,6.63,2.17,2.56-.23,5.1-1.8,6.8-4.2,1.47-2.08,2.37-4.74,2.67-7.92.15-1.54.16-3.26.05-5.39,0-.16,0-.36,0-.59,0-.68,0-2.09-.5-2.23-.22-.06-.62.02-.98.09-.24.05-.5.1-.73.11-.73.05-1.48.03-2.22-.05-1.46-.15-2.87-.54-4.2-1.15-.68-.31-1.33-.68-1.93-1.09l-.14-.1c-.23-.15-.42-.28-.6-.4-.4,2.75-1.69,5.39-3.62,7.38-.9.92-1.73,1.48-2.62,1.77-1.19.39-2.46.2-3.31-.48-.42-.34-.71-.75-.98-1.15-.23-.33-.44-.63-.7-.86-.86-.75-2.43-.57-3.29.38-.81.9-1.06,2.37-.64,3.75.69,2.27,3.09,3.94,5.46,3.77.01,0,.03,0,.04,0M147.77,40.44c-2.29,0-4.69-.87-6.68-2.46-1.8-1.44-3.3-3.42-4.47-5.91-2.79,0-5.42-1.93-6.24-4.61-.55-1.79-.21-3.66.89-4.88,1.29-1.42,3.59-1.65,4.93-.48.37.32.63.71.89,1.08.24.35.47.68.75.91.55.44,1.4.55,2.22.28.7-.23,1.38-.7,2.14-1.48,2.03-2.08,3.27-4.94,3.41-7.84h0c.02-.32.29-.58.61-.56.25.01.46.18.53.41.1.11.39.35,1.14.84l.17.11c.55.38,1.14.71,1.75,1,1.21.56,2.5.91,3.84,1.05.68.07,1.35.08,2.02.04.16-.01.36-.05.58-.09.48-.1,1.03-.2,1.52-.07,1.37.37,1.36,2.24,1.36,3.36,0,.2,0,.38,0,.52.12,2.19.1,3.96-.05,5.56h0c-.32,3.39-1.29,6.24-2.88,8.48-1.89,2.68-4.75,4.43-7.65,4.69-.26.02-.52.03-.78.03",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21,25.85c1.36.31,2.47,1.5,2.69,2.87l-2.69-2.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,29.31c-.28,0-.53-.2-.58-.49-.19-1.13-1.13-2.14-2.25-2.4-.31-.07-.51-.39-.44-.7.07-.31.39-.51.7-.44,1.59.37,2.88,1.74,3.14,3.35.05.32-.16.62-.48.67-.03,0-.06,0-.1,0",
    style: {
      fill: "#1d1d1b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione03Img01);
export default __webpack_public_path__ + "static/media/sezione-03-img-01.9ca620dbdb677d777f935952e48db64f.svg";
export { ForwardRef as ReactComponent };